/**
 * Defines the Transport seams the menu builder and asset creator call out
 * to (window.ThMenuBuilderTransport.submitMenu, window.ThAssetCreatorTransport
 * .submitAsset). Both just POST to the print service
 * (funkin-tradehub-print-service repo) — the backend that holds the
 * WooCommerce credentials and does the PDF/order work this static theme
 * can't.
 *
 * Endpoints are read from globals set inline per-section (see
 * sc-menu-builder.liquid / sc-asset-creator.liquid), not hardcoded here, so
 * they can be changed from the theme editor once the service is deployed
 * without touching this file.
 */
(function () {
  'use strict';

  function submit(url, payload) {
    if (!url) {
      return Promise.reject(new Error('No print service endpoint configured for this section'));
    }
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    }).then(function (res) {
      if (!res.ok) {
        return res
          .json()
          .catch(function () { return null; })
          .then(function (body) {
            throw new Error((body && body.error) || 'Print order submission failed (' + res.status + ')');
          });
      }
      return res.json();
    });
  }

  window.ThMenuBuilderTransport = window.ThMenuBuilderTransport || {
    submitMenu: function (payload) {
      return submit(window.ThMenuOrdersEndpoint, payload);
    },
  };

  window.ThAssetCreatorTransport = window.ThAssetCreatorTransport || {
    submitPrint: function (payload) {
      return submit(window.ThAssetOrdersEndpoint, payload);
    },
  };
})();
